// Иконка гаража
export const createGarageIcon = (color = 'black') => {
  const svgString = `
<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 20H4.6C4.03995 20 3.75992 20 3.54601 19.891C3.35785 19.7951 3.20487 19.6422 3.10899 19.454C3 19.2401 3 18.9601 3 18.4V9.0398C3 8.66343 3 8.47524 3.05919 8.31095C3.1115 8.16573 3.19673 8.03458 3.30819 7.9278C3.43428 7.80699 3.60625 7.73056 3.95018 7.5777L12 4L20.0498 7.5777C20.3938 7.73056 20.5657 7.80699 20.6918 7.9278C20.8033 8.03458 20.8885 8.16573 20.9408 8.31095C21 8.47524 21 8.66343 21 9.0398V18.4C21 18.9601 21 19.2401 20.891 19.454C20.7951 19.6422 20.6422 19.7951 20.454 19.891C20.2401 20 19.9601 20 19.4 20H17M7 20H17M7 20V14M17 20V14M7 14V10H17V14M7 14H17" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `;
  const blob = new Blob([svgString], { type: 'image/svg+xml' });
  return URL.createObjectURL(blob);
};

// Иконка склада нефтепродуктов
export const createStorageIcon = (color = 'black') => {
  const svgString = `
<svg fill="${color}" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
   width="40" height="40" viewBox="0 0 427.551 427.551"
   xml:space="preserve">
<g>
  <g>
    <polygon points="309.215,285.564 265.725,295.461 265.725,320.54 309.215,310.643 		"/>
    <path d="M309.215,48.781c-16.043,0.183-30.924,1.187-43.49,2.796v24.088l43.49-9.896V48.781z"/>
    <polygon points="309.215,163.167 265.725,173.063 265.725,198.062 309.215,188.166 		"/>
    <polygon points="309.215,81.514 265.725,91.411 265.725,116.492 309.215,106.595 		"/>
    <polygon points="309.215,122.341 265.725,132.238 265.725,157.316 309.215,147.42 		"/>
    <polygon points="309.215,244.738 265.725,254.635 265.725,279.713 309.215,269.816 		"/>
    <polygon points="309.215,203.995 265.725,213.889 265.725,238.887 309.215,228.991 		"/>
    <polygon points="82.3,260.293 50.287,267.579 50.287,285.978 82.3,278.693 		"/>
    <polygon points="82.3,290.284 50.287,297.569 50.287,316.03 82.3,308.744 		"/>
    <path d="M82.3,146.16c-12.213,0.886-23.121,2.275-32.014,4.037v15.632l32.014-7.284V146.16z"/>
    <polygon points="82.3,230.24 50.287,237.524 50.287,255.924 82.3,248.641 		"/>
    <polygon points="82.3,170.135 50.287,177.42 50.287,195.879 82.3,188.594 		"/>
    <polygon points="82.3,200.189 50.287,207.472 50.287,225.933 82.3,218.649 		"/>
    <path d="M401.93,343.879C401.949,264.338,402,65.618,402,65.43c0-8.901-36.582-16.173-82.646-16.654v295.104h-10.139v-17.487
      l-43.49,9.896v7.594h-10.14V53.094c-17.578,3.05-28.61,7.448-28.61,12.335c0,0.188,0.081,198.91,0.116,278.449h-26.277
      c0.023-59.871,0.072-181.941,0.072-182.121c0-9.214-39.18-16.681-87.514-16.681c-8.182,0-16.098,0.215-23.609,0.615v198.187H59.97
      l22.33-5.08v-18.461l-32.014,7.283v16.258h-7.461V151.886c-10.664,2.766-16.965,6.179-16.965,9.871
      c0,0.179,0.072,122.25,0.107,182.121H0v34.897h427.551v-34.896H401.93z"/>
  </g>
</g>
</svg>
  `;
  const blob = new Blob([svgString], { type: 'image/svg+xml' });
  return URL.createObjectURL(blob);
};
